import MaskInput from 'vue-3-mask';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('MaskInput', MaskInput);
});